import { motion } from "framer-motion";
import { FADE_UP_30, VISIBLE, VIEWPORT, TITLE_TRANSITION, EASE } from "@/lib/motion";

const SERVICES = [
  { n: "01", title: "Brand Incubation", body: "Instagram-native to scalable D2C.", tags: ["Positioning", "Launch"], span: "md:col-span-7" },
  { n: "02", title: "Paid Media", body: "Google, Meta, TikTok, Programmatic — engineered for unit economics.", tags: ["Search", "Meta", "Programmatic"], span: "md:col-span-5" },
  { n: "03", title: "Cross-border Commerce", body: "4-continent distribution, geo-tiered acquisition, currency-aware pricing.", tags: ["4 continents", "Cross-border"], span: "md:col-span-5" },
  { n: "04", title: "LTV & Cohort", body: "Sustainable growth over one-off acquisition spikes.", tags: ["LTV", "Retention"], span: "md:col-span-7" },
  { n: "05", title: "Creative that Converts", body: "UGC-driven creatives, shoppable ads, A/B tested landing pages.", tags: ["UGC", "Shoppable"], span: "md:col-span-6" },
  { n: "06", title: "Data & Attribution", body: "UTM taxonomy, CAPI, server-side tracking, dashboards that surface signal.", tags: ["UTM", "CAPI"], span: "md:col-span-6" },
];

const ServiceCard = ({ service: s, index: i }) => (
  <motion.article
    initial={FADE_UP_30}
    whileInView={VISIBLE}
    viewport={VIEWPORT}
    transition={{ duration: 0.9, delay: i * 0.05, ease: EASE }}
    className={`col-span-12 ${s.span} card-tech p-8 md:p-10 group flex flex-col`}
    data-testid={`services-card-${s.n}`}
  >
    <div className="flex items-center justify-between">
      <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-laser">{s.n}</div>
      <div className="w-8 h-px bg-stroke group-hover:bg-laser transition-colors" />
    </div>
    <h3 className="mt-8 md:mt-12 font-serif font-light text-3xl md:text-4xl text-ink leading-tight tracking-tight">
      {s.title}
    </h3>
    <p className="mt-4 font-sans text-base md:text-lg text-ink/70 leading-relaxed max-w-lg">
      {s.body}
    </p>
    <div className="mt-6 flex flex-wrap gap-2">
      {s.tags.map((t) => (
        <span key={t} className="font-mono text-[10px] tracking-[0.16em] uppercase text-ink/70 border border-stroke px-3 py-1.5 group-hover:border-laser/60 transition-colors">
          {t}
        </span>
      ))}
    </div>
  </motion.article>
);

export default function Services() {
  return (
    <section id="services" className="relative container-x py-24 md:py-40" data-testid="services-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-20">
        <div className="col-span-12 md:col-span-4">
          <p className="eyebrow">Digital Centaur &mdash; My Studio</p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <motion.h2
            initial={FADE_UP_30}
            whileInView={VISIBLE}
            viewport={VIEWPORT}
            transition={TITLE_TRANSITION}
            className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.96] tracking-tight text-ink"
            data-testid="services-title"
          >
            What I build for the brands I partner with.
          </motion.h2>
          <p className="mt-6 font-sans text-lg text-steel max-w-xl leading-relaxed">
            Six workstreams. One growth engine.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-3 md:gap-4" data-testid="services-grid">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.n} service={s} index={i} />
        ))}
      </div>
    </section>
  );
}
